import type { ComboboxItem, ComboboxLikeRenderOptionInput } from "@mantine/core";
import { RegularIcon } from "@/components/ui/FontAwesomeIcon";
import styles from "./theme-dropdown-option.module.scss";

/**
 * Global Select/MultiSelect option renderer: label on the leading edge, a
 * FontAwesome "check" on the trailing edge of the selected row. Wired into the
 * theme's Select/MultiSelect `defaultProps.renderOption` so every DS dropdown
 * shows the SAME check glyph as our Menu-based selectors — Mantine's built-in
 * CheckIcon (a different, chunkier glyph) is skipped whenever `renderOption` is
 * set. The selected/hover neutral-1 fill is owned by the dropdown theme
 * (`_ds-input.scss` / `Combobox.scss` / `Menu.scss`).
 *
 * The label is a plain <span> (not Mantine <Text>) so it inherits the option's
 * font-size and the selected row's medium weight; it grows and wraps so long
 * option text never overflows the row or overlaps the check.
 */
export function renderDropdownOption({
  option,
  checked,
}: ComboboxLikeRenderOptionInput<ComboboxItem>) {
  return (
    <span className={styles.Option}>
      <span className={styles.Label}>{option.label}</span>
      {checked ? <RegularIcon icon="check" size="xs" /> : null}
    </span>
  );
}
